/* eslint-disable */

import xml2jsobj from 'xml2jsobj';

export default class BinfoToStream {
  convert(pData) {
    let stream = {};
    xml2jsobj.convert(
      pData,
      (err, result) => {
        if (!err && result) {
          result = this.processBinfo(result);
          if (result) {
            stream = {
              result: 'ok',
              data: result,
            };
          } else {
            stream = { result: 'error' };
          }
        }
      },
    );
    return stream;
  }

  processBinfo(binfo) {
    let result = {};
    if (binfo.name === 'CONFIG' && binfo.children && binfo.children.length > 0) {
      result = {};
      let localResult, j, p, prop, child;  
      const nodes = binfo.children;
      for (let i = 0, l = nodes.length; i < l; ++i) {
        if (nodes[i].name === 'SRC') {
          result.src = BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'TITLE') {
          result.title = BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'TYPE') {
          result.type = BinfoToStream.getChildlessNodeValue(nodes[i]);
          result.is_tv = result.type === 'TV';
        } else if (nodes[i].name === 'SHARELINK') {
          localResult = BinfoToStream.getChildlessNodeValue(nodes[i]);
          result.share_link = localResult;
          localResult = localResult.match(/\d+/);
          if (localResult && localResult.length > 0) {
            try {
              result.video_id = Number(localResult[0]);
            } catch (error) {
              console.error(error.message);
            }
          }
        } else if (nodes[i].name === 'SHOWCLOSEBUTTON') {
          result.showCloseButton = BinfoToStream.getChildlessNodeValue(nodes[i]) === 'true';
        } else if (nodes[i].name === 'WATERMARKURL') {
          result.watermarkURL = BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'RESULTINGREFFERERHOST') {
          result.resultingrefererhost = BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'WATERMARKISCLICKABLE') {
          result.watermarkIsClickable = BinfoToStream.getChildlessNodeValue(nodes[i]) === 'true';
        } else if (nodes[i].name === 'PLAYER_BG') {
          result.player_bg = BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'AUTOPLAY') {
          result.autoplay = BinfoToStream.getChildlessNodeValue(nodes[i]) === 'true';
          result.autoPlay = BinfoToStream.getChildlessNodeValue(nodes[i]) === 'true';
        } else if (nodes[i].name === 'VODCHANNEL') {
          result.is_vod_channel = BinfoToStream.getChildlessNodeValue(nodes[i]) === 'true';
        } else if (nodes[i].name === 'DVRCHANNEL') {
          result.is_dvr_channel = BinfoToStream.getChildlessNodeValue(nodes[i]) === 'true';
        } else if (nodes[i].name === 'PLAYSTARTTIME') {
          result.play_start_time = BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'NEXT') {
          result.next = BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'PREV') {
          result.prev = BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'ADVERTURL') {
          result.advert_url = BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'ADVERTDATA') {
          result.advert_data = BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'CONTENTTYPE') {
          localResult = BinfoToStream.getChildlessNodeValue(nodes[i]);
          result.contentType = localResult;
          result.content_type = localResult;
          result.is_live = 'live' === localResult || 'tv_dvr' === localResult || 'tv_linear' === localResult || 'm_ch' === localResult || 'live_dvr' === localResult;
        } else if (nodes[i].name === 'VIDEOSTAT') {
          result.start_session_url = BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'SHOWBESTQUALITYLINK') {
          result.showBestQualityLink = 'true' === BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'SHARE') {
          result.player_share_code = 'true' === BinfoToStream.getChildlessNodeValue(nodes[i]);
        }
        else if (nodes[i].name === 'BITRATES') {
          localResult = [];
          if (nodes[i].children && nodes[i].children.length > 0) {
            let bitrate;
            for (j = 0, p = nodes[i].children.length; j < p; ++j) {
              bitrate = {};
              child = nodes[i].children[j];
              if (child.attributes) {
                for (prop in child.attributes) {
                  try {
                    if (prop === 'VALUE') {
                      bitrate['bitrate'] = Number(child.attributes[prop]);
                    } else {
                      bitrate[prop.toLowerCase()] = Number(child.attributes[prop]);
                    }
                  } catch (error) {

                  }
                }
              }
              bitrate.name = BinfoToStream.getChildlessNodeValue(child);
              localResult.push(bitrate);
            }
          }
          result.bitrates = localResult;
        } else if (nodes[i].name === 'THUMBSXML') {
          if (!result.preview_images) {
            result.preview_images = {};
          }
          result.preview_images.thumbsline_xml = BinfoToStream.getChildlessNodeValue(nodes[i])
        } else if (nodes[i].name === 'THUMBS') {
          if (!result.preview_images) {
            result.preview_images = {};
          }
          localResult = [];
          if (nodes[i].children && nodes[i].children.length > 0) {
            let thumbline;
            for (j = 0, p = nodes[i].children.length; j < p; ++j) {
              thumbline = {};
              child = nodes[i].children[j];
              if (child.attributes) {
                for (prop in child.attributes) {
                  if (prop === 'ID') {
                    try {
                      thumbline.id = Number(child.attributes[prop]);
                    } catch (error) {
                      console.error(error.message)
                    }
                  } else {
                    thumbline[prop.toLowerCase()] = child.attributes[prop];
                  }
                }
              }
              localResult.push(thumbline);
            }
          }
          result.preview_images.thumbsline_list = localResult;
        } else if (nodes[i].name === 'AUDIOTRACKS') {
          localResult = [];
          if (nodes[i].children && nodes[i].children.length > 0) {
            let audioTrack;
            for (j = 0, p = nodes[i].children.length; j < p; ++j) {
              audioTrack = {};
              child = nodes[i].children[j];
              if (child.attributes) {
                for (prop in child.attributes) {
                  try {
                    audioTrack[prop.toLowerCase()] = Number(child.attributes[prop]);
                  } catch (error) {
                    console.log(error.message);
                  }
                }
              }
              audioTrack.lang_original = BinfoToStream.getChildlessNodeValue(child);
              audioTrack.display_name = BinfoToStream.getChildlessNodeValue(child);
              audioTrack.lang = BinfoToStream.getChildlessNodeValue(child);
              localResult.push(audioTrack);
            }
          }
          result.audio_tracks = localResult;
        } else if (nodes[i].name === 'SUBTITLES') {
          localResult = [];
          if (nodes[i].children && nodes[i].children.length > 0) {
            let subtitles;
            for (j = 0, p = nodes[i].children.length; j < p; ++j) {
              subtitles = {};
              child = nodes[i].children[j];
              if (child.attributes) {
                subtitles.index = j;
                for (prop in child.attributes) {
                  if (prop === 'NAME') {
                    subtitles.lang_original = child.attributes[prop];
                    subtitles.display_name = child.attributes[prop];
                    subtitles.lang = child.attributes[prop];
                    subtitles.lang_tag = child.attributes[prop];
                  } else if (prop === 'TYPE') {
                    subtitles[prop.toLowerCase()] = child.attributes[prop].toLowerCase();
                  } else {
                    subtitles[prop.toLowerCase()] = child.attributes[prop];
                  }
                }
              }
              subtitles.url = BinfoToStream.getChildlessNodeValue(child);
              localResult.push(subtitles);
            }
          }
          result.subtitles = localResult;
        } else if (nodes[i].name === 'EMBED') {
          result.is_embed = 'true' === BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (i === 35 || nodes[i].name === 'EPGURL') {
          result.epg_url = BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'CHANNELS') {
          const mainResult = [];
          if (nodes[i].children && nodes[i].children.length > 0) {
            let genres = nodes[i].children,
              genre, channels, channel, genreResult, channelResult;
            for (j = 0, p = genres.length; j < p; ++j) {
              genre = genres[j];
              genreResult = { title: '', channels: [] };
              mainResult.push(genreResult);
              if (genre.attributes && genre.attributes.TITLE) {
                genreResult.title = genre.attributes.TITLE;
              }
              if (genre.children && genre.children.length > 0) {
                channels = genre.children;
                for (let k = 0, c = channels.length; k < c; ++k) {
                  channel = channels[k];
                  channelResult = { epgId: 0, isFavorite: false, id: 0 };
                  genreResult.channels.push(channelResult);
                  if (channel.attributes) {
                    if (channel.attributes.EPGID) {
                      try {
                        channelResult.epgId = Number(channel.attributes.EPGID);
                      } catch (error) {
                      }
                    }
                    if (channel.attributes.ISFAVORITE) {
                      channelResult.isFavorite = channel.attributes.ISFAVORITE;
                    }
                    if (channel.attributes.VODCHANNEL) {
                      channelResult.vodChannel = channel.attributes.VODCHANNEL;
                    }
                    if (channel.attributes.DVRCHANNEL) {
                      channelResult.dvrChannel = channel.attributes.DVRCHANNEL;
                    }
                  }
                  try {
                    channelResult.id = Number(BinfoToStream.getChildlessNodeValue(channel));
                  } catch (error) {
                  }
                }
              }
            }
          }
          result.channels = mainResult;
        } else if (nodes[i].name === 'MESSAGES') {
          localResult = {};
          if (nodes[i].children && nodes[i].children.length > 0) {
            const messages = nodes[i].children;
            let message;
            for (let k = 0, c = messages.length; k < c; ++k) {
              message = messages[k];
              if (message.name === 'MONTHS') {
                localResult.months = {};
                for (j = 0, p = message.children.length; j < p; ++j) {
                  localResult.months[message.children[j].name.toLowerCase()] = BinfoToStream.getChildlessNodeValue(message.children[j]);
                }
              } else {
                localResult[message.name.toLowerCase()] = BinfoToStream.getChildlessNodeValue(message);
              }
            }
          }
          result.messages = localResult;
        } else if (nodes[i].name === 'DRMDASH') {
          localResult = {};
          if (nodes[i].children && nodes[i].children.length > 0) {
            const servers = nodes[i].children;
            for (j = 0, p = servers.length; j < p; ++j) {
              if (servers[j].attributes && servers[j].attributes.NAME) {
                localResult[servers[j].attributes.NAME] = BinfoToStream.getChildlessNodeValue(servers[j]);
              }
            }
          }
          result.is_wvdrm = true;
          result.wvls = localResult;
        } else if (nodes[i].name === 'SELFPROMO') {
          result.is_subscription = 'true' === BinfoToStream.getChildlessNodeValue(nodes[i]);
        } else if (nodes[i].name === 'DRM') {
          result.is_wvdrm = 'true' === BinfoToStream.getChildlessNodeValue(nodes[i]);
        }
      }
    }
    if (!result.video_id) {
      result.video_id = -1;
    }

    return result;
  }


  static getChildlessNodeValue(node) {
    let result = '';
    if (node && node.children && node.children.length > 0) {
      [result] = node.children;
    }
    return result;
  }
}
